import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, MenuController, NavController, ToastController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { OrderService, OrdersListDto, StoreResponseDto } from 'src/generated_client';
import { PopoverController } from '@ionic/angular';
import { PopoverOrderConfirmComponent } from '../popover-order-confirm/popover-order-confirm.component';
import { SingalRService } from 'src/app/services/singnal-r.service';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
})
export class OrderSummaryComponent implements OnInit {

  store: StoreResponseDto;
  totalsData: Totals = {} as Totals;
  isLoaded: boolean;
  allAccepted: OrdersListDto[] = [];
  allCompleted: OrdersListDto[] = [];
  textButton: string;
  hiddenButton: boolean = false;
  columns: number = 6;
  showOnTheWay: boolean;
  showFinish: boolean;
  loading: HTMLIonLoadingElement;
  private hubConnection!: signalR.HubConnection;

  slideOpts = {
    initialSlide: 0,
    speed: 400,
    centerSlides: true,
    slidesPerView: 1
  };

  constructor(
    public orderService: OrderService,
    public loadingController: LoadingController,
    public authService: AuthService,
    private menu: MenuController,
    private router: Router,
    private toastController: ToastController,
    private nav: NavController,
    private popoverController: PopoverController,
    private _signalRService: SingalRService
  ) {
    this.menu.enable(true, 'custom');
  }

  async ngOnInit() {
    this.store = this.authService.currentUserStore();
  }

  async ionViewWillEnter() {

    this.InitializeSingalR();

    await this.presentLoading();

    this.orderService.apiOrderTotalOrdersByStoreGet(this.store.cdStore).subscribe(response => {

      this.totalsData = {
        totalOrders: response.totalOrders,
        completed: response.totalfinalized
      }

      this.isLoaded = true;
      this.loadOrdersList();
    },
      error => {
        if (error.status == 401) {
          this.router.navigate(['/login']);
          this.loading.dismiss()
        }

        this.loading.dismiss();
      });
  }

  public async ionViewDidLeave() : Promise<void>{
    await this.closeSingalR();
  }

  public async confirmOrder(order: OrdersListDto) {

    await this.presentLoading();

    const popover = await this.popoverController.create({
      component: PopoverOrderConfirmComponent,
      componentProps: {
        order
      },
      translucent: true,
      animated: true,
      cssClass: 'my-custom-class',
    });

    await popover.present().then(async () => {
      await this.loading.dismiss()
    });

    await popover.onDidDismiss().then(async (response: any) => {

      if (response.data && response.data.optionSelected) {
        await this.aceptOrder(order, response);
      }
    });
  }

  public async changeStatusToOnTheWay(cdOrder: number) {

    await this.presentLoading();

    this.orderService.apiOrderOnTheWayPut(cdOrder).subscribe(async x => await this.loading.dismiss()
      , err => {

        let msj = err.error.error;
        this.presentToast(msj);
        this.loading.dismiss();
      });
  }

  public async changeStatusToFinish(cdOrder: number) {

    await this.presentLoading();

    this.orderService.apiOrderConfirmDeliverPut(cdOrder).subscribe(async x => await this.loading.dismiss()
      , err => {

        let msj = err.error.error;

        this.presentToast(msj);

        this.loading.dismiss();
      });
  }

  public async viewOrder(order: OrdersListDto) {
    await this.router.navigate(['/orders-details/' + order.cdOrder]);
  }

  public async refresh(event: any) {
    await this.loadOrdersList(event);
  }

  private async loadOrdersList(event?: any) {

    this.orderService.apiOrderGetActiveDailyByStoreGet(this.store.cdStore).subscribe(async response => {

      this.allAccepted = response;

      if (this.allAccepted.length == 0) {

        this.orderService.apiOrderGetAllAcceptedByStoreGet(this.store.cdStore).subscribe(async response => {

          this.allAccepted = response;

          await this.loading.dismiss();

          if (event)
            event.target.complete();

        }, error => {

          if (error.status == 401) {

            this.nav.navigateForward('/login');

            this.loading.dismiss();

            if (event)
              event.target.complete();
          }
        })
      }
      else {

        await this.loading.dismiss();

        if (event)
          event.target.complete();
      }
    });

    this.orderService.apiOrderGetDayilyCompletedByStoreGet(this.store.cdStore).subscribe(response => {

      this.allCompleted = response;

      if (this.allCompleted.length == 0) {
        this.orderService.apiOrderGetAllCompletedByStoreGet(this.store.cdStore).subscribe(response => {

          this.allCompleted = response;
          this.loading.dismiss()

          if (event)
            event.target.complete()
        }, error => {

          if (error.status == 401) {
            this.nav.navigateForward('/login');
            this.loading.dismiss();

            if (event)
              event.target.complete();
          }
        });
      }
    });
  }

  private async presentToast(message: string) {

    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });

    toast.present();
  }

  private async presentLoading() {

    if (this.loading)
      await this.loading.dismiss();

    this.loading = await this.loadingController.create({
      message: 'Cargando...',
    });

    await this.loading.present();
  }

  private async aceptOrder(order: OrdersListDto, response: any) {

    await this.presentLoading();

    await this.orderService.apiOrderConfirmOrderPut(order.cdOrder, response.data.optionSelected)
      .toPromise()
      .then(async (response) => {

        if (response) {
          await this.loading.dismiss();
        }
      })
      .catch(error => {

        let errorMsj = error.error.error;

        if (errorMsj)
          this.presentToast(errorMsj);

        else
          this.presentToast("Ocurrieron errores, intente mas tarde");

        this.loading.dismiss();
      });
  }

  private InitializeSingalR() {

    this._signalRService.startConnection();
    this._signalRService.addToGroupWithStart(String(this.store.cdStore));

    this.hubConnection = this._signalRService.getHubConnection();

    this.hubConnection.on("UpdateOrdersInStore", async () =>  {

      await this.presentLoading();
      await this.loadOrdersList();
    });
  }

  private async closeSingalR() {
    await this.hubConnection.stop();
  }
}

interface Totals {
  totalOrders: number,
  completed: number
}
